import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { Form } from "./Form";
import { Table } from "./Table";
import useToggle from "../../hooks/useToggle";
import { IHotel } from "../../models/BaseModel";
import { HotelAminites } from "./HotelAminities";

export interface IOpenForm {
    open: boolean,
    singleData: IHotel,
    type: 'form' | 'aminity' | 'hide'
}

export const Hotel = ({ hasPermission }: { hasPermission: (pageName: string, featureName?: string) => boolean }) => {

    const [modal, setModal] = useState({ singleData: {}, open: false } as IOpenForm);
    const [reload, reloadData] = useToggle();
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: {}, open: false, type: 'hide' });
    };

    return (
        <>
            {(hasPermission("Hotel", "Add") || hasPermission("Hotel", "Edit")) && <Form hasPermission={hasPermission} singleData={modal.singleData} open={modal.open && modal.type === 'form'} hideDialog={hideDialog} toast={toast} reloadData={reloadData}></Form>}
            {hasPermission("Hotel", "Aminity") && <HotelAminites hotel={modal.singleData} open={modal.open && modal.type === 'aminity'} hideDialog={hideDialog} toast={toast} />}
            <Table hasPermission={hasPermission} setModal={setModal} toast={toast} reload={reload} reloadData={reloadData} />
            <Toast ref={toast} />
        </>
    );
}
